import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyCustomRoles = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-custom-roles", jiraSpaEntry: "async-jira-eoc-custom-roles" */ '@atlassian/jira-eoc-custom-roles'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyCustomRoles} pageId="async-eoc-custom-roles" shouldShowSpinner={false} />
);
